export interface Tomo {
  number: string
  short: string
  title: string
  detail: string
  spine: string
}

export const tomos: Tomo[] = [
  {
    number: '01',
    short: 'Lógica',
    title: 'Lógica y razonamiento',
    detail: '40 ejercicios de secuencias, patrones y decisiones cotidianas.',
    spine: 'bg-blue-300',
  },
  {
    number: '02',
    short: 'Memoria',
    title: 'Memoria y recuerdos',
    detail: '40 ejercicios que activan historias y momentos propios.',
    spine: 'bg-blue-400',
  },
  {
    number: '03',
    short: 'Atención',
    title: 'Atención y visión',
    detail: '40 ejercicios de búsqueda visual, detalle y concentración.',
    spine: 'bg-blue-500',
  },
  {
    number: '04',
    short: 'Lenguaje',
    title: 'Lenguaje y expresión',
    detail: '40 ejercicios de vocabulario, fluidez y expresión clara.',
    spine: 'bg-blue-600',
  },
  {
    number: '05',
    short: 'Movimiento',
    title: 'Movimiento y coordinación',
    detail: '40 ejercicios de motricidad, ritmo y coordinación fina.',
    spine: 'bg-blue-700',
  },
  {
    number: '06',
    short: 'Diario',
    title: 'Diario de reflexión e integración',
    detail: 'Registro diario para cerrar, integrar y ver el progreso.',
    spine: 'bg-blue-900',
  },
]

export const includedFeatures: string[] = [
  'Protocolo Activa-15: 15 minutos por día',
  'Adaptaciones según la energía del día',
  'Registro de progreso semana a semana',
  '100% basado en evidencia científica',
  'Listo para imprimir, sin apps ni claves',
  'Instrucciones simples para el acompañante',
]

export interface Bonus {
  tag: string
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    tag: 'Bono 1',
    title: 'Ruta Express 30 días',
    description: 'Calendario diario listo. No tenés que pensar qué hacer cada mañana.',
  },
  {
    tag: 'Bono 2',
    title: 'Manual del Acompañante',
    description: 'Frases listas, protocolos y cómo acompañar sin frustrar a nadie.',
  },
  {
    tag: 'Bono 3',
    title: 'Tarjetas de Conexión Familiar',
    description: '80 preguntas para volver a conversar de verdad, en profundidad.',
  },
]

export const painPoints: string[] = [
  'Meses buscando ejercicios sin saber si funcionan',
  'Conversaciones que siempre son iguales',
  'Miedo a que se siga deteriorando',
  'Cuidador agotado, sin relevo',
  'Sin estructura y sin consistencia',
]

export interface ShortQuote {
  initials: string
  quote: string
  author: string
  city: string
}

export const heroQuotes: ShortQuote[] = [
  {
    initials: 'MG',
    quote: 'En un mes vi cambios reales. Mi mamá habla más claro y está más confiada.',
    author: 'Mariela G.',
    city: 'Córdoba',
  },
  {
    initials: 'LP',
    quote: 'Los ejercicios de memoria la conectaron con historias perdidas. Invaluable.',
    author: 'Laura P.',
    city: 'Rosario',
  },
  {
    initials: 'RM',
    quote: 'Organizamos todo el mes en una tarde. Mi papá por fin tiene rutina clara.',
    author: 'Roberto M.',
    city: 'Buenos Aires',
  },
]

export const deepQuotes: ShortQuote[] = [
  {
    initials: 'CR',
    quote: 'Mi mamá duerme mejor. Yo duermo mejor. El manual me salvó.',
    author: 'Cecilia R.',
    city: 'Mendoza',
  },
  {
    initials: 'RM',
    quote: 'Dejé de corregir todo. Ahora solo escucho. La relación mejoró.',
    author: 'Roberto M.',
    city: 'Buenos Aires',
  },
  {
    initials: 'SC',
    quote: 'En el asilo los abuelos mejoraron notablemente. Las familias, sorprendidas.',
    author: 'Sofía C.',
    city: 'La Plata',
  },
]

export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿Funciona a cualquier edad?',
    answer: 'Sí. De 60 a 100+ años. Cada ejercicio se adapta según la energía del día.',
  },
  {
    question: '¿Necesito saber de pedagogía?',
    answer: 'No. Todo está paso a paso. El Manual del Acompañante te enseña qué decir en cada momento.',
  },
  {
    question: '¿Cuánto tiempo toma prepararse?',
    answer: 'Cero. Descargás, imprimís y empezás. La Ruta Express te dice qué hacer cada día.',
  },
  {
    question: '¿Y si tiene demencia?',
    answer: 'Funciona incluso con demencia leve. Las adaptaciones para cada caso están incluidas.',
  },
]

export const costWithout: string[] = [
  '2-3 horas por semana buscando "qué hacer"',
  'Ejercicios que no conectan',
  'Conversaciones superficiales',
  'Deterioro acelerado',
  'Cuidador agotado',
  'El mismo ciclo, otra vez, el próximo mes',
]

export const costWith: string[] = [
  'Rutina clara, sin pensarla',
  'Resultados visibles en 4 semanas',
  'Conexión genuina',
  'Mente preservada',
  'Cuidador sostenible',
  'Transformación real',
]

export const checkoutUrl = 'https://mi-mejor-version.impultienda.ar'

export interface Offer {
  name: string
  summary: string
  includes: string[]
  listPrice: string
  price: string
  cta: string
}

export const offer: Offer = {
  name: 'MegaPack Método Mente Viva',
  summary: '6 Tomos (200 ejercicios) + 3 Bonos gratis',
  includes: [
    '6 Tomos con 200 ejercicios científicos',
    'Protocolo Activa-15: 15 minutos por día',
    'BONO 1: Ruta Express 30 días',
    'BONO 2: Manual del Acompañante',
    'BONO 3: Tarjetas de Conexión Familiar',
    '100% PDF, listo para imprimir',
  ],
  listPrice: '$51.000',
  price: '$19.990',
  cta: 'Quiero mi Método Mente Viva ahora',
}

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/3Eq58bs4p7hNuTcHT2d9ze/mockup2.png'

export const lifestyleImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/b3737aee-042f-4294-9ca3-44d69da5794b.jpg'
